import React, { useState } from "react";

import Select from "react-select";

export const ReactSelect = ({
  data,
  handleChange,
  selectedValue,
  nameCombo,
  size,
}) => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      // This line disable the blue border
      boxSizing: "border-box",
      borderRadius: "10px",
      cursor: "pointer",
      border: "2px solid #cccccc !important",
      boxShadow: state.isFocused
        ? "0px 0px 15px rgb(0 0 0 / 20%) !important"
        : "none !important",

      "&:hover": {
        outline: "none",
        boxShadow: " 0px 0px 15px rgb(0 0 0 / 20%) !important",
        border: "2px solid #cccccc !important",
      },
      "&:focus": {
        boxShadow: "0px 0px 15px rgb(0 0 0 / 20%) !important",
        border: "2px solid #cccccc;",
      },
    }),
    option: (
      styles,
      { data: dataOption, isDisabled, isFocused, isSelected }
    ) => {
      return {
        ...styles,
        backgroundColor: isSelected ? "#fd7e14" : null,
        cursor: "pointer",
        ":hover": {
          backgroundColor: "#fd7e14ab",
          color: "white",
        },
      };
    },
    menuList: (
      styles,
      { data: dataMenuList, isDisabled, isFocused, isSelected }
    ) => {
      return {
        ...styles,
        height: size === "small" ? "200px" : null,
      };
    },
  };

  return (
    <Select
      // key={nameCombo}
      options={data}
      value={data.find(({ value }) => Number(value) === Number(selectedValue))}
      name={nameCombo}
      onChange={(value, action) => {
        handleChange(value, action);
      }}
      isDisabled={data.length > 0 ? false : true}
      placeholder={data.length > 0 ? "Seleccione..." : "Cargando..."}
      styles={customStyles}
      theme={(theme) => ({
        ...theme,
        borderRadius: 14,
        boxShadow: "none",

        colors: {
          ...theme.colors,
          primary25: "#c4c4c4",
          primary: "#0054b2",
        },
      })}
    />
  );
};
